<template>
  <div class="xliarticle-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Select v-model="formItem.area1" clearable placeholder="省" @on-change="shengChange">
              <Option v-for="item in shengList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select v-model="formItem.area2" clearable placeholder="市" @on-change="shiChange">
              <Option v-for="item in shiList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select v-model="formItem.area3" clearable placeholder="县">
              <Option v-for="item in quList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入献礼人名称或电话..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable(1)">查找</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer
      :title="title"
      v-model="showModalStatus"
      width="1200"
      :mask-closable="false"
      :styles="styles"
    >
      <Form :model="article" ref="articleValidate" action="javascript:void(0)">
        <FormItem label="姓名">
          <Input v-model="article.name" placeholder="请输入姓名" />
        </FormItem>
        <FormItem label="电话">
          <Input v-model="article.phone" placeholder="请输入电话" />
        </FormItem>
        <FormItem label="省-市-县" label-position="top">
          <Select v-model="article.area1" placeholder="省" @on-change="shengChange">
            <Option v-for="item in shengList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label=" " label-position="top">
          <Select v-model="article.area2" placeholder="市" @on-change="shiChange">
            <Option v-for="item in shiList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label=" " label-position="top">
          <Select v-model="article.area3" placeholder="县">
            <Option v-for="item in quList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label="描述">
          <Input type="textarea" v-model="article.describe" :rows="3" placeholder="请输入描述" />
        </FormItem>
        <FormItem label="内容">
          <Input type="textarea" v-model="article.content" :rows="3" placeholder="请输入内容" />
        </FormItem>
        <FormItem label="封面图">
          <upload-thumb
            v-model="article.thumb"
            ref="uploadthumb"
            :defaultList="thumblist"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:670*385,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="相册">
          <upload-thumb
            v-model="article.works"
            ref="uploadthumbTwo"
            :defaultList="thumblistTwo"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:217*217,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus = false">取消</Button>
        <Button type="primary" @click="createpushtype('articleValidate')">提交</Button>
      </div>
    </Drawer>
    <!-- 审核弹框 -->
    <Form :model="articledata" action="javascript:void(0)">
      <Modal v-model="showStatus" title="审核" @on-ok="reviewarticle()" :loading="dataloading">
        <FormItem label="审核状态" label-position="top">
          <RadioGroup v-model="articledata.status">
            <Radio label="0">待审核</Radio>
            <Radio label="1">通过</Radio>
            <Radio label="-1">不通过</Radio>
          </RadioGroup>
        </FormItem>
      </Modal>
    </Form>
    <!-- 审核弹框 end -->
    <!-- 助力用户弹层 start-->
    <Drawer
      width="50"
      v-model="modal1"
      title="助力用户"
      :mask-closable="false"
      @on-cancel="modal1 = false"
    >
      <Row>
        <Col :xs="24" :md="24">
          <Table border stripe :columns="columshelps" :data="datahelps"></Table>
        </Col>
      </Row>
    </Drawer>
    <!-- 助力用户弹层 end -->
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";

export default {
  name: "xliarticle-list",
  data() {
    return {
      title: "献礼",
      loading: true,
      dataloading: true,
      modal1: false,
      showModalStatus: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      articledata: {
        status: "0"
      },
      article: {},
      formItem: {
        key: ""
      },
      shengList: [],
      shiList: [],
      quList: [],
      thumblist: [],
      thumblistTwo: [],
      columns: [
        {
          title: "Id",
          key: "id",
          width: 50
        },
        {
          title: "献礼人姓名",
          key: "name",
          width: 100
        },
        {
          title: "献礼人电话",
          key: "phone",
          width: 150
        },
        {
          title: "献礼人头像",
          key: "thumb",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: this.$publicData.ossUrl+params.row.thumb,
                    shape: "square",
                    size: "large"
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: "地区",
          key: "diqu",
          minWidth: 200,
          render: (h, params) => {
            var s = "";
            if (params.row.area1 != null) s = params.row.area1.areaname;
            if (params.row.area2 != null)
              s = s + "->" + params.row.area2.areaname;
            if (params.row.area3 != null)
              s = s + "->" + params.row.area3.areaname;
            return h("div", [h("span", {}, s)]);
          }
        },
        {
          title: "简介",
          key: "describe",
          width: 300
        },
        {
          title: "发言",
          key: "content",
          width: 300
        },
        {
          title: "助力值",
          key: "help_num",
          width: 80
        },
        {
          title: "评论数",
          key: "comments_num",
          width: 80
        },
        {
          title: "作品",
          key: "works",
          width: 300,
          render: (h, params) => {
            var that = this;
            if (params.row.works == null) {
              return;
            }
            var il = JSON.parse(params.row.works);
            var imgListObj = new Array();
            for (var i = 0; i < il.length; i++) {
              var showImg = this.$publicData.ossUrl+il[i];
              imgListObj.push(
                h("img", {
                  style: {
                    width: "50px",
                    height: "50px"
                  },
                  attrs: {
                    src: showImg
                  }
                })
              );
            }
            return h("div", imgListObj);
          }
        },
        {
          title: "状态",
          key: "status",
          width: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.status == "0"
                ? "未审核"
                : params.row.status == "1"
                ? "审核通过"
                : "未通过审核"
            );
          }
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          fixed: "right",
          width: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                    // display: params.row.status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id);
                    }
                  }
                },
                "审核"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.commentlist(params.row.id);
                    }
                  }
                },
                "评论列表"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.helplist(params.row.id);
                    }
                  }
                },
                "助力列表"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      datahelps: [],
      columshelps: [
        {
          title: "用户uuid",
          key: "uuid",
          width: 200,
          align: "center"
        },
        {
          title: "名称",
          key: "name",
          width: 200,
          align: "center"
        }
      ],
      search: {
        status: "0"
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      showStatus: false
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  created: function() {
    // 取数据
    this.getTableList();
    this.getShengList();
  },
  methods: {
    getTableList: function() {
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.xliarticle.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getShengList() {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    shengChange(value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    shiChange(value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    },
    commentlist: function(id) {
      this.$router.push(`/xliarticlecomment/list/${id}`);
    },
    review: function(id) {
      this.articleid = id;
      this.showStatus = !this.showStatus;
      this.$api.xliarticle.detail({ articleid: this.articleid }).then(res => {
        if (res.code == 200) {
          this.articledata.status = res.result.status.toString();
        }
      });
    },
    // 审核
    reviewarticle: function(name) {
      this.$api.xliarticle
        .review({ id: this.articleid, status: this.articledata.status })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    //展开修改
    showEditInfo: function(index) {
      this.articleid = index;
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.showModalStatus = !this.showModalStatus;
      this.$api.xliarticle.detail({ articleid: index }).then(res => {
        if (res.code == 200) {
          this.article = res.result;
          //省市区三个下拉框
          this.shiList = this.article.shiList;
          this.quList = this.article.quList;
          if (this.article.thumb != null && this.article.thumb != "") {
            this.thumblist.push({
              name: this.article.thumb,
              url: this.article.thumb,
              status: "finished"
            });
          }

          if (
            this.article.works != "" &&
            this.article.works != null &&
            this.article.works.length > 0
          ) {
            for (var s in this.article.attrShow) {
              this.thumblistTwo.push({
                name: this.article.attrShow[s],
                url: this.article.attrShow[s],
                status: "finished"
              });
            }
          }
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加/修改
    createpushtype(name) {
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.article.thumb = this.$refs["uploadthumb"].uploadList[0].url;
      } else {
        this.article.thumb = null;
      }

      // 图+文 有相册
      if (this.$refs["uploadthumbTwo"].uploadList.length > 0) {
        var finalAttrs = "";
        var tList = this.$refs["uploadthumbTwo"].uploadList;
        for (var s in tList) {
          finalAttrs = finalAttrs + tList[s].url + ",";
        }
        if (finalAttrs != "") {
          this.article.works = finalAttrs.substring(0, finalAttrs.length - 1);
        }
      } else {
        this.article.works = null;
      }

      //编辑商品
      this.article.articleid = this.articleid;
      this.$api.xliarticle.edit({ data: this.article }).then(res => {
        if (res.code == 200) {
          this.getTableList();
          this.showModalStatus = false;
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key,
        area1: this.formItem.area1,
        area2: this.formItem.area2,
        area3: this.formItem.area3
      };
      this.$api.xliarticle.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 查助力用户
    helplist: function(index) {
      this.modal1 = true;
      var params = {
        articleid: index
      };
      this.$api.xliarticle.helplist(params).then(res => {
        if (res.code == 200) {
          this.datahelps = res.result;
        }
      });
      return;
    }
  }
};
</script>
